<div class="header-container">
    <div class="search-wrapper" style="justify-content: space-between">
        <div class="search-container">
            <app-search-field id="resource-search" [searchTerm]="searchTerm" (doSearch)="onSearch($event)"
                              width="300px"></app-search-field>
        </div>
    </div>
    <div style="display: flex; align-items: flex-end;">
        <ng-container *ngTemplateOutlet="additionalRightContent"></ng-container>
        <app-reset-filter-btn [disableClearFilter]="disableClearFilter" (resetFilter)="reset()"></app-reset-filter-btn>
    </div>
</div>
